import script from "./QuizSidebarMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizSidebarMobile.vue?vue&type=script&setup=true&lang=js"

import "./QuizSidebarMobile.vue?vue&type=style&index=0&id=870f3352&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-870f3352"]])

export default __exports__